import { render, staticRenderFns } from "./ManagementDetailsHeader.vue?vue&type=template&id=56f6da86&scoped=true"
import script from "./ManagementDetailsHeader.vue?vue&type=script&lang=js"
export * from "./ManagementDetailsHeader.vue?vue&type=script&lang=js"
import style0 from "./ManagementDetailsHeader.vue?vue&type=style&index=0&id=56f6da86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f6da86",
  null
  
)

export default component.exports